<div class="auth-support">
  Возникла проблема?
  <button
    type="button"
    class="auth-support__link"
    (click)="supportService.showSupportChat()"
  >
    Напишите нам
  </button>
</div>
